
// region JS Imports

// region External Modules
import u from "umbrellajs"

import I18n from "plugins/i18n-js"
import * as Routes from "plugins/js-routes"
// endregion External Modules

// Private Modules
import {
  q_ajax_3,
} from "app/utils/q_ajax/q_ajax_3"
// Private Modules

// region Public Components
import Carousel from "concepts/buildings/images/carousel/index"
// endregion Public Components

// region Private Components
// endregion Private Components

// endregion JS Imports


const DEFAULT_SELECTOR = {
  scope:      ".cell--buildings--floorplan--with-photo",
  overlay:    ".page-section--overseas-real-estate-projects-floorplan-photos--overlay",
  photo:      ".page-section--overseas-real-estate-projects-floorplan-photos-section_photo",
  close_btn:  ".page-section--overseas-real-estate-projects-floorplan-photos--overlay__close-btn",
}

const init = () => {
  const $scope = u(DEFAULT_SELECTOR.scope)
  const $overlay = u(DEFAULT_SELECTOR.overlay)
  const $photo = u(DEFAULT_SELECTOR.photo)
  const $close_btn = u(DEFAULT_SELECTOR.close_btn)

  $photo.on("click", (e) => {
    const $this = u(e.currentTarget as HTMLElement)
    const building_id = $this.data("building-id")
    openCarousel(building_id)
  })

  $close_btn.on("click", () =>
    $overlay.each((el) => {
      el.style.display = "none"
    })
  )

  function openCarousel(building_id: number | string) {
    $overlay.each((el) => {
      el.style.display = "initial"
    })

    q_ajax_3({
      // # The only path that cannot be generated from current url
      url:      Routes.floor_plans_building_path(I18n.locale, building_id),
      method:   "GET",
      dataType: "html",
    })
    .then(({data}) => {
      $overlay.find(".page-section--overseas-real-estate-projects-floorplan-photos--overlay__body").html(data)
      Carousel.init()
    })
    .done()
  }
}

export default {init}
